import React from "react";
import MainContainer from "../../components/MainContainer";
import { Link } from "react-router-dom";
import useDocumentTitle from "../../hooks/useDocumentTitle";
import { useAuth } from "../../providers/AuthProvider";

const ConfirmationPage = () => {
  const { authUser } = useAuth();

  useDocumentTitle("Επισκόπηση των στοιχείων σας");

  return (
    <MainContainer>
      <div className="col-lg-8">
        <h1 className="mb-4">Επισκόπηση των στοιχείων σας</h1>
        <p>
          Επιβεβαιώστε ότι τα παρακάτω στοιχεία, με τα οποία έχετε συνδεθεί,
          είναι σωστά.
        </p>
        <dl className="row datalist my-5 mx-0">
          <dt className="col-sm-4">Όνομα</dt>
          <dd className="col-sm-8">{authUser?.firstname}</dd>
          <dt className="col-sm-4">Επώνυμο</dt>
          <dd className="col-sm-8">{authUser?.lastname}</dd>
          <dt className="col-sm-4">Α.Φ.Μ.</dt>
          {/* TODO! Replace with **** if needed */}
          <dd className="col-sm-8">{authUser?.taxid}</dd>
        </dl>
        <Link
          to={
            // location.pathname.includes("ticket-office")
            //   ? "/ticket-office/choose-user"
            "/tickets/choose-action"
          }
          className="btn btn-primary btn-lg btn-login"
        >
          {authUser?.TICKET_ROLE === "OFFICER" ? "Πολίτης" : "Συνέχεια"}
        </Link>
        {authUser?.TICKET_ROLE === "OFFICER" ? (
          <Link
            to={"/ticket-office/choose-user"}
            className="btn btn-primary btn-lg btn-login ms-3"
          >
            Υπάλληλος ΠΑΕ
          </Link>
        ) : null}
      </div>
    </MainContainer>
  );
};

export default ConfirmationPage;
